import React, { Component } from "react";
import { OwnImage } from "@img/module-images";
import { ApiBody, BASE_URL, ServerRequest } from "@utils/utils-server-request";
import { ContentLoader } from "@module-layout/loader/ContentLoader";



export class MyAppsSlider extends Component<any,  any> {
  static defaultProps = {};
  constructor(props: any){
    super(props)
    this.state = {
      isFetching: false,
      apps: [],
      appsData: {},
    }
  }

  componentDidMount(): void {
    this.getData();
  }

  getData = () => {
    const config: ApiBody  = {
      endpoint: 'api/banner_apps.json',
    }
    if(!this.state.isFetching){
      this.setState({isFetching: true})
      new ServerRequest(BASE_URL).get( config, ({data, isFound, isError, isFetching}) =>{
        if(isFound){
          this.setState({ isFound, isError, isFetching, apps: data})
          this.getDataDetails(data, 0)
        }else if(isError){
          // this.setState({ isFound, isError, isFetching})
        }
      })
    }
  }

  getDataDetails = (arr: Array<any>, index: number) => {
    if(arr.length < 1) return null;
    const item = arr[index];
    if(this.state.appsData[item] && index <=  arr.length - 1){
      this.getDataDetails(arr, index+1)
      return null
    }
    const config: ApiBody  = {
      endpoint: `api/app_${item}.json`,
    }
    new ServerRequest(BASE_URL).get( config, ({data, isFound, isError, isFetching}) =>{
      if(isFound){
        const details = this.state.appsData;
        details[item] = data;
        this.setState({ appsData: details})
        if(index <=  arr.length - 1){
          this.getDataDetails(arr, index+1)
        }
      }else if(isError){
        if(index <=  arr.length - 1){
          this.getDataDetails(arr, index+1)
        }
      }
    })
  }


  render(){
    const { props, state } = this;
    return(
      <>
        {state.isFetching &&
          [1,2,3,4,5,6].map((item: any, i: number) => (
            <div className="box oneleft " style={{padding: '5px'}} key={i}>
              <ContentLoader arrLength = {1}  isShow = {true} height = {"50%"} />
            </div>
          ))
        }
        { state.apps.map((item: any, i: number) => {
          const appItem = state.appsData[item];
          if(!appItem){
            return (
              <div className="backimg after2 slide25">
                <ContentLoader arrLength = {1}  isShow = {true} height = {"50%"} />
              </div>
            )
          }
          return (
            <div className="backimg after2 slide25" style={{backgroundImage: `url(${appItem.image?.[0]?.src})`}} key = {i}>
              <div className="m1 oneinfo absolute" style={{paddingTop: '100px'}}>
                <div className="onec-blue">{appItem.title}</div>
                <div style={{padding: '20px'}}><a className="onebg-blue btn" href={`/ridwan/store/view/?id=${appItem.id}`}>GET IT NOW</a></div>
              </div>
              <div className="ban" />
            </div>
          )
        })}
      </>
    )
  }
}